import { createSearchBannerModule } from './factory/searchBanner';

export default createSearchBannerModule({
  apiType: 'db-restaurants',
  amountLabelField: 'people_label',
  amountOptionsField: 'people_options',
  amountValueField: {
    getResponse: 'num_people',
    postRequest: 'num_people',
    postResponse: 'people',
  },
});
